/**
*
*   Signup Footer
*       - The Signup Area on the Footer
*
**/
'use client';

import Config from '@/config';
import moment from 'moment';
import DOMPurify from 'dompurify';
import Preloader from '@/components/preloader';
import Button from '@/components/button';
import Article from '@/libraries/article';
import Storefront from '@/libraries/shopify/class';
import ShopifyTools from '@/libraries/shopify-tools/class';
import { ModalContext } from '@/context/modal';
import { useState, useEffect, useContext } from 'react';
import { useTranslations, useLocale } from 'next-intl';



//Build the Element
export default function Comments({ blog , article, ...props }){

    const t = useTranslations();

    const { Modal } = useContext(ModalContext);

    const [ loading , setLoading ] = useState(true);

    const [ comments , setComments ] = useState([]);

    const Page = {

        //The Page Loading
        load: async () => {

/*
            //Prepare the params
            const params = new URLSearchParams({
                blog_id:        ShopifyTools.id( blog.id ),
                article_id:     ShopifyTools.id( article.id )
            })

            //Get the Comments
            const response = await (
                await fetch( '/api/comments?' + params.toString() )
            ).json();
*/
            const response = await Storefront.Article.comments( article.id );

            //Update Comments
            if( response.result ) setComments( ( response.body?.comments || [] ) );

            //Remove Loading
            setLoading(false);

        },


        //Load the Form
        form: () => Modal.open({
            comment: {
                blog: blog,
                article: article
            },
            callback: () => Page.load()
        })
    }

    //Load the Comments
    useEffect(()=>{
        Page.load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    //Return
    return (
        <section id="conversations">

            {/* Header */}
            <header className="subcontainer">
                <h2>{ t('Components.Comments.title') }</h2>
                <div className="summary">
                    { comments.length > 0 && (
                        <p className="total">{ t('Components.Comments.total',{ total: comments.length }) }</p>
                    )}
                    <div className="actions">
                        { comments.length == 0 && (
                            <Button onClick={()=>Page.form()}>{ t('Components.Comments.start') }</Button>
                        )}
                        { comments.length > 0 && (
                            <Button onClick={()=>Page.form()}>{ t('Components.Comments.add') }</Button>
                        )}
                    </div>
                </div>
            </header>

            {/* Comments */}
            <div id="comments" className="container">
                <Preloader status={ loading } />
                <ul>
                    { ( comments || [] ).map( comment => (

                        <li key={ comment.id }>
                            <div className="wrap">
                                <div className="header">
                                    <p className="author">
                                        <strong>{ comment.author.name }</strong>
                                    </p>
                                    {/*}
                                    <small>{ moment( comment.created_at ).format('LLL') }</small>
                                    */} 
                                </div>
                                <div className="content" dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize( comment.contentHtml )
                                }}>
                                </div>
                                <div className="footer">
                                    <p className="author">
                                        <strong>{ comment.author.name }</strong>
                                    </p>
                                    {/*}
                                    { moment( comment.created_at ).format('LLL') }
                                    */}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>

            </div>


        </section>
    );

}